import { TextField } from "@mui/material";
import React, { FC, useState } from "react";

export const DiscursivaComponent: FC<{
  qtdeEtapas: number;
  etapaAtual: number;
  etapa: number;
  nomeEtapa: string;
  discursiva: string;
  setDiscursiva: (v: string) => void;
}> = ({
  qtdeEtapas,
  etapaAtual,
  etapa,
  nomeEtapa,
  discursiva,
  setDiscursiva,
}) => {
  const [value, setValue] = useState(discursiva);
  return (
    <TextField
      sx={{
        "& .MuiInputBase-root": {
          paddingTop: qtdeEtapas == 1 ? 1 : undefined,
        },
      }}
      label={
        qtdeEtapas > 1
          ? `${qtdeEtapas == 1 ? etapaAtual : etapa + 1}º ${nomeEtapa}`
          : undefined
      }
      multiline
      rows={3}
      value={value}
      onChange={({ target: { value } }) => setValue(value)}
      onBlur={() => setDiscursiva(value)}
    />
  );
};
